import { X } from 'lucide-react';

export interface FilterChip {
  key: string;
  label: string;
  onRemove: () => void;
}

/** Removable "Filtered by:" chip row shown above search results when filters are active. */
export function FilterChips({ chips, onClear }: { chips: FilterChip[]; onClear: () => void }) {
  if (chips.length === 0) return null;
  return (
    <div className="mt-4 flex flex-wrap items-center gap-2">
      <span className="text-xs font-medium text-muted-foreground">Filtered by:</span>
      {chips.map((c) => (
        <button
          key={c.key}
          type="button"
          onClick={c.onRemove}
          className="inline-flex items-center gap-1 rounded-full border border-border bg-muted/50 px-2.5 py-1 text-xs text-foreground transition-colors hover:bg-muted"
        >
          {c.label}
          <X className="h-3 w-3 opacity-60" />
        </button>
      ))}
      {chips.length > 1 && (
        <button type="button" onClick={onClear} className="text-xs text-muted-foreground underline hover:text-foreground">
          Clear all
        </button>
      )}
    </div>
  );
}
